<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="container-fluid">
                        <div class="assessmentHeader">
                            <div class="row">
                                <div class="col-md-10">
                                    <h3>Assessment</h3>
                                </div>
                                <div class="col-md-2 text-right">
                                    <div>
                                        <i *ngIf="from_clients" [routerLink]="['/app/new360']" class="material-icons">undo</i>
                                        <ng-container *ngIf="!_assessmentEnd">
                                            <i *ngIf="!nextQuestions" (click)="next()" class="rotate180 material-icons">keyboard_backspace</i>
                                            <i *ngIf="nextQuestions" (click)="assessmentEnd()" class="rotate180 material-icons">keyboard_backspace</i>
                                        </ng-container>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                        <div *ngIf="!_assessmentEnd">
                            <p *ngIf="!nextQuestions">How would you rate Mary's ability to:</p>
                            <p *ngIf="nextQuestions">To what extent does Mary appear to:</p>

                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <ng-container *ngIf="!nextQuestions">
                                                <th *ngFor="let title of tableTitles">{{title}}</th>
                                            </ng-container>
                                            <ng-container *ngIf="nextQuestions">
                                                <th *ngFor="let title of tableTitles2">{{title}}</th>
                                            </ng-container>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="!nextQuestions">
                                            <ng-container *ngFor="let question of questions">
                                                <tr>
                                                    <td width="40%"><span class="text-left">{{question}}</span></td>
                                                    <td *ngFor="let title of tableTitles" align="center"><div (click)="selectCircle($event)" class="circle"></div></td>
                                                </tr>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="nextQuestions">
                                            <ng-container *ngFor="let question of questions2">
                                                <tr>
                                                    <td width="40%"><span class="text-left">{{question}}</span></td>
                                                    <td *ngFor="let title of tableTitles2" align="center"><div (click)="selectCircle($event)" class="circle"></div></td>
                                                </tr>
                                            </ng-container>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                        <div *ngIf="_assessmentEnd" class="text-center finalMessage">
                            <h3>
                                {{finalMessage}}
                            </h3>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
